import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { CustomButton } from 'src/components/ui'
import { useGetTypeOfBottleFromUrl } from 'src/hooks'
import { useCreateBottle } from 'src/zustand/stores/createBottle.store'

import styles from './InputNameOfBottle.module.scss'

const InputNameOfBottle = () => {
  const { t } = useTranslation()
  const inputRef = React.useRef<HTMLInputElement>(null)
  const addBottleName = useCreateBottle((state) => state.addBottleName)
  const bottleName = useCreateBottle((state) => state.bottleName)

  const [inputValue, setInputValue] = React.useState(bottleName)
  const navigate = useNavigate()

  const typeOfBottle = useGetTypeOfBottleFromUrl()

  const handleContinued = () => {
    addBottleName(inputValue)
    navigate(`/create-bottle/step-3?type=${typeOfBottle}`)
  }

  const handleChangeInputValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    setInputValue(value)

    e.target.style.width = `${Math.max(value.length)}ch`
  }

  React.useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus()
    }
  }, [])

  return (
    <div className={styles.wrapper}>
      <div className={styles.wrapper_input}>
        <label htmlFor='input'>{t('create_bottle.input_name_bank')}</label>
        <input
          ref={inputRef}
          type='text'
          value={inputValue}
          onChange={handleChangeInputValue}
          style={{ width: `${Math.max(inputValue.length + 0.5, 1)}ch` }}
        />
      </div>
      <div className={styles.tabs}>
        <CustomButton
          onClick={handleContinued}
          variant={inputValue.length === 0 ? 'not-active' : 'contained'}
          color='white'
          className={styles.button}
        >
          {t('create_bottle.continue')}
        </CustomButton>
      </div>
    </div>
  )
}

export default InputNameOfBottle
